// extracted by mini-css-extract-plugin
export default {"root":"RentedBadge_root__4UEtf","label":"RentedBadge_label__nsYL9","divider":"RentedBadge_divider__Z03i5","creator":"RentedBadge_creator__mwAqN","days":"RentedBadge_days__gf5WY"};